import qs from 'qs';
import { client } from '@/client';

// 获取topic概览
export function getTopicOverview(clusterName) {
  return client.get(`/api/metrics/topic/${clusterName}/overview`);
}

// topic列表
export function getTopicList(params) {
  const { clusterName, ...others } = params;
  return client.get(`/api/metrics/topic/${clusterName}/list`, others);
}

// topic列表服务端
export function getTopicListServerPaginate(params) {
  return client.post(`/api/metrics/topic/list`, params);
}

// 获取所有namespace
export async function getNamespacesOptions(params) {
  const { data } = await client.get('/api/console/security/getAllNamespaces', params);
  return data.map((item) => ({
    label: item,
    value: item,
  }));
}

// 图表接口
export function getTopicChartData(params) {
  const { clusterName, ...others } = params;
  return client.get(`/api/monitor/topic/${clusterName}`, others);
}

// 图表接口-分区
export function getTopicPartitionChartData(params) {
  const { clusterName, ...others } = params;
  return client.get(`/api/monitor/topic/partition/${clusterName}`, others);
}

// 创建topic
export function createTopic(params) {
  return client.put('/api/resource/topic/create', params);
}

// 批量删除Topic
export function delTopicBatch(params) {
  return client.delete('/api/resource/topic/batchDelete', params);
}

// 删除Topic
export function delTopic(params) {
  return client.delete('/api/resource/topic/delete', params);
}

// 单个topic总览
export function getTopicDetailOverView(params) {
  const { clusterName, ...others } = params;
  return client.get(`/api/metrics/topic/${clusterName}`, others);
}

// 修改数据
export function updateMetadata(params) {
  return client.post('/api/console/topic/update-metadata', params);
}

export function getStats(params) {
  return client.get('/api/resource/topic/stats', params);
}

export function getInternalStats(params) {
  return client.get('/api/resource/topic/internal-stats', params);
}

// 卸载
export function doUnload(params) {
  return client.put(
    `/api/resource/topic/unload?clusterName=${params.clusterName}&topic=${params.topic}`,
    params,
  );
}

// 更新分区扩容
export function updatePartitionNum(params) {
  return client.put(
    `/api/resource/topic/update-partition-num${qs.stringify(params, { addQueryPrefix: true })}`,
    params,
  );
}

// 获取分区信息
export function getPartition(params) {
  const { clusterName, ...others } = params;
  return client.get(`/api/metrics/topic/partition/${clusterName}`, others);
}

// 分区bundle信息
export function getPartitionBundle(params) {
  const { clusterName, ...others } = params;
  return client.get(`/api/metrics/topic/partition/${clusterName}/bundle`, others);
}

// 删除授权
export function deletePermission(params) {
  return client.delete('/api/resource/topic/revoke-role-permissions', params);
}

// 获取授权列表
export function getTopicGrantList(params) {
  const { clusterName, ...others } = params;
  return client.get(`/api/metrics/topic/${clusterName}/role`, others);
}

// 新增授权
export function grantPermissions(params) {
  return client.put('/api/resource/topic/grant-role-permissions', params);
}

// 更新授权
export function undatePermissions(params) {
  return client.put('/api/resource/topic/update-role-permissions', params);
}

// schema
export function getSchemaList(params) {
  return client.get('/api/resource/topic/schema', params);
}

// 获取配置信息
export function getPolices(params) {
  const { clusterName, ...others } = params;
  return client.get(`/api/metrics/topic/${clusterName}/polices`, others);
}

// 更新消息保留策略
export function updateRetentionPolicy(params) {
  return client.put('/api/resource/topic/update-retention-policy', params);
}
// 持久化策略
export function updatePersistencePolicy(params) {
  return client.put('/api/resource/topic/update-persistence-policy', params);
}
export function updateClientLimitPolicy(params) {
  return client.put('/api/resource/topic/update-client-limit-policy', params);
}

// 限流策略
export function updateLimitPolicy(params) {
  return client.put('/api/resource/topic/update-limit-policy', params);
}

// schema兼容策略
export function updateSchemaCompatibilityPolicy(params) {
  return client.put('/api/resource/topic/update-schema-compatibility-policy', params);
}

// 高级配置
export function getProPolices(params) {
  const { clusterName, ...others } = params;
  return client.get(`/api/metrics/topic/${clusterName}/advancedPolices`, others);
}
// 删除订阅
export function deleteSubscription(params) {
  return client.delete('/api/resource/topic/subscription/delete', params);
}

// 修改复制状态
export function setReplicatedStatus(params) {
  return client.put(`/api/resource/topic/subscription/set-replicated-status`, params);
}

// 创建订阅
export function createSubscription(params) {
  return client.put(
    `/api/resource/topic/subscription/create${qs.stringify(params, { addQueryPrefix: true })}`,
    params,
  );
}

export function getExamineMsg(params) {
  const { clusterName, ...others } = params;
  return client.get(`/api/resource/message/${clusterName}/examineMessage`, others);
}

export function peekMessages(params) {
  const { clusterName, ...others } = params;
  return client.get(`/api/resource/message/${clusterName}/peekMessages`, others);
}

export function getMessageById(params) {
  const { clusterName, ...others } = params;
  return client.get(`/api/resource/message/${clusterName}/getMessageById`, others);
}

export function getStorages(params) {
  const { clusterName, ...others } = params;
  return client.get(`/api/metrics/topic/${clusterName}/storages`, others);
}

export function getLedgerMeta(params) {
  return client.get('/api/metrics/topic/ledger/metadata', params);
}

export function getGeoOutList(params) {
  const { clusterName, ...others } = params;
  return client.get(
    `/api/metrics/geo/topic/nonPartition/replicationStatOut/${clusterName}`,
    others,
  );
}

export function getPartitionGeoOutList(params) {
  const { clusterName, ...others } = params;
  return client.get(`/api/metrics/geo/topic/partition/replicationStatOut/${clusterName}`, others);
}

export function getGeoInList(params) {
  const { clusterName, ...others } = params;
  return client.get(`/api/metrics/geo/topic/nonPartition/replicationStatIn/${clusterName}`, others);
}

export function getPartitionGeoInList(params) {
  const { clusterName, ...others } = params;
  return client.get(`/api/metrics/geo/topic/partition/replicationStatIn/${clusterName}`, others);
}

export function deleteGeo(params) {
  const { clusterName, ...others } = params;
  return client.delete(`/api/resource/geo/topic/deleteReplicationCluster/${clusterName}`, others);
}

export function createGeo(params) {
  const { clusterName, ...others } = params;
  return client.put(
    `/api/resource/geo/topic/addReplicationCluster/${clusterName}${qs.stringify(others, {
      addQueryPrefix: true,
    })}`,
    others,
  );
}

export function getGeoChartData(params) {
  const { clusterName, ...others } = params;
  return client.get(`/api/monitor/geo/topic/nonPartition/${clusterName}`, others);
}

export function getPartionGeoChartData(params) {
  const { clusterName, ...others } = params;
  return client.get(`/api/monitor/geo/topic/partition/${clusterName}`, others);
}

// 查看key归属
export function keyHashRangeMatch(params) {
  const { clusterName, ...others } = params;
  return client.get(`/api/metrics/topic/subscription/keyHashRangeMatch/${clusterName}`, others);
}

export function deleteGeoPolice(params) {
  const { clusterName, ...others } = params;
  return client.delete(`/api/resource/geo/topic/removeRatePolice/${clusterName}`, others);
}

export function getGeoPolice(params) {
  const { clusterName, ...others } = params;
  return client.get(`/api/metrics/geo/topic/ratePolice/${clusterName}`, others);
}

export function updateGeoPolice(params) {
  return client.put(`/api/resource/geo/topic/updateRatePolice`, params);
}
